import { ToastOptions } from '@app/storybook/services/toast/toast-types';
import { RuleEngineState } from './RuleEngineState';

export enum RuleEngineConfigPropertyTypes {
  Number = 'number',
  String = 'string',
  Weight = 'weight',
  Autocomplete = 'autocomplete',
  Stepper = 'stepper',
  ContainsTextOrIsAutocomplete = 'containsTextOrIsAutocomplete',
  Dropdown = 'dropdown',
  NestedDropdown = 'nestedDropdown',
}

export interface RuleEngineConfigProperty {
  type: RuleEngineConfigPropertyTypes;
  property: Property;
  measuringUnit?: string;
  conditionalType?: (operator: Operator) => RuleEngineConfigPropertyTypes;
}

export interface RuleEngineVisualConfig {
  tooltipAppearOnAltSide?: 'left';
}

export interface RuleEngineConfig {
  properties: RuleEngineConfigProperty[];
  visualConfig?: RuleEngineVisualConfig;
}

export interface RuleEngineBindings {
  viewMode?: boolean;
  onChange?: (state: RuleEngineState, valid: boolean) => void;
  showValidationErrors?: boolean;
  hideMatchAllRuleGroupsTab?: boolean;
  showToast?: (opts: ToastOptions) => void;
  fetchAutocompleteValues?: (property: Property, input?: string) => Promise<string[]>;
}

export enum Property {
  customerOrderCount = 'Customer order count',
  weight = 'Weight',
  vendor = 'Vendor',
  collection = 'Collection',
  productType = 'Product type',
  cartValue = 'Cart value',
  shopify_tags = 'Product tags',
  customerTag = 'Customer tags',
  country = 'Destinations',
  subscription = 'Subscription',
  source = 'Source',
  customerSpend = 'Customer Spend',
  weekday = 'Weekday',
  hasACoupon = 'Has a Coupon',
  grossMargin = 'Gross Margin',
  gender = 'Gender',
  productMetafield = 'Product Metafield',
  variantMetafield = 'Variant Metafield',
  variantTitle = 'Variant title',
  sellingPlan = 'Selling plan',
  cartAttributeKey = 'Cart Attribute Key',
  cartAttributeValue = 'Cart Attribute Value',
  propertiesValue = 'Properties Value',
  propertiesKey = 'Properties Key',
  locale = 'Locale',
  timeOfDay = 'Time of Day',
}

export enum Operator {
  equals = 'is equals to',
  not_equals = 'is not equals to',
  is_more_than = 'is greater than',
  is_less_than = 'is less than',
  is_more_than_or_equal_to = 'is greater than or equal to',
  is_less_than_or_equal_to = 'is less than or equal to',
  is = 'is',
  is_not = 'is not',
  is_only = 'is only',
  contains = 'contains',
  not_contains = 'not contains',
  is_any = 'is any',
  is_all = 'is all',
}
